import { Tabs } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../ricos-context/index.js";
import { logInvariant } from "./../../_shared/log-invariant.js";
import { PmNodeType } from "./../../_shared/pm-node-types.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import {
  Panel,
  PanelHeader,
  useClickOutside,
  usePanelContainerElement
} from "./../../ui-components/index.js";
import { IMAGE_EDITOR_COLOR_PICKER_MODAL_ID, IMAGE_SETTINGS_MODAL_ID } from "../consts.js";
import { SETTINGS_IMAGE_TABS, SETTINGS_MODAL } from "../data-hooks.js";
import classes from "../statics/styles/settings-modal-scss.js";
import { DesignTab } from "./design-tab.js";
import { SettingsTab } from "./settings-tab.js";
const ImageTabValue = {
  SETTINGS: "settings",
  DESIGN: "design"
};
const Settings = ({
  nodeId,
  config,
  referenceElement,
  initialTab = ImageTabValue.SETTINGS
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext) || {};
  const containerEl = usePanelContainerElement();
  const { pmNodeAttrs, patchPmNodeAttrs } = useNodeAttrs(nodeId, PmNodeType.IMAGE);
  const [activeTab, setActiveTab] = useState(initialTab);
  const isColorPickerModalOpen = () => modalService.isModalOpen(IMAGE_EDITOR_COLOR_PICKER_MODAL_ID);
  const closeModal = () => modalService.closeModal(IMAGE_SETTINGS_MODAL_ID);
  useClickOutside({
    containerRef: { current: containerEl },
    onClickOutside: (e) => {
      const target = e.target;
      if (referenceElement?.contains(target)) {
        return;
      }
      closeModal();
    },
    disable: isColorPickerModalOpen()
  });
  if (!pmNodeAttrs) {
    logInvariant(new Error("Image settings: node attrs not found"));
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      onCloseButtonClick: () => modalService.closeModal(IMAGE_SETTINGS_MODAL_ID),
      dataHook: SETTINGS_MODAL
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title: t("ImageSettings_Header") }),
    /* @__PURE__ */ React.createElement(
      Tabs,
      {
        dataHook: SETTINGS_IMAGE_TABS,
        className: classes.tabs,
        size: "small",
        alignment: "center",
        type: "uniformFull",
        minWidth: 0,
        activeId: activeTab,
        onClick: (value) => setActiveTab(value.id),
        items: [
          { id: ImageTabValue.SETTINGS, title: t("ImagePlugin_Settings_Tab_Settings") },
          { id: ImageTabValue.DESIGN, title: t("ImagePlugin_Settings_Tab_Design") }
        ]
      }
    ),
    activeTab === ImageTabValue.SETTINGS && /* @__PURE__ */ React.createElement(SettingsTab, { pmNodeAttrs, patchPmNodeAttrs }),
    activeTab === ImageTabValue.DESIGN && /* @__PURE__ */ React.createElement(
      DesignTab,
      {
        pmNodeAttrs,
        patchPmNodeAttrs,
        nodeId,
        config
      }
    )
  );
};
export {
  ImageTabValue,
  Settings
};
//# sourceMappingURL=settings.js.map
